import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { CURATION_STATUS } from 'domains/scraper-product/constants'

/**
 * To give nice look in curation status for scraper product
 */
const propTypes = {
  curation_status: PropTypes.string
}

const ScraperProductCurationStatusBadge = ({ curation_status }) => {

  const colorMap = {
    [CURATION_STATUS.PENDING]               : 'warning',
    [CURATION_STATUS.AUTO_CURATION_FAILED]  : 'danger',
    [CURATION_STATUS.CURATED_AUTOMATICALLY] : 'success',
    [CURATION_STATUS.CURATED_MANUALLY]      : 'primary',
    [CURATION_STATUS.REJECTED]              : 'danger'
  }

  const color = colorMap[curation_status] || 'default'

  return <StatusBadge color={ color } label={ curation_status } />
}

ScraperProductCurationStatusBadge.propTypes = propTypes

export default ScraperProductCurationStatusBadge
